import { AttributesMixin, define, Model, type } from "@type-r/models";
import { Invoice } from "./invoice";

export interface InvoiceVaultCard extends AttributesMixin<typeof InvoiceVaultCard> { }
@define
export class InvoiceVaultCard extends Model {

    static idAttribute = "id";

    static attributes = {
        stateId: Number,
        createdOn: type(Date),
        uid: String,
        dataset: type(Invoice).dontSave,
        hashKey: String,
        updatedOn :type(Date),
        eTag: String,
        assetTypeId: Number,
        isArchived: Boolean,
        dataSourceId: Number,
        sourceAssetId: Number,
        platformCode: String,
        createdBy: String,
        updatedBy: String,
        number: String,
        checked: type(Boolean)
    };
}
